import { useState } from 'react'
import { submitPasswordResetConfirmation } from '../api/submitPasswordResetConfirmation'
import { apiRequest } from '../utils/apiRequest'

export function usePasswordResetConfirmation() {
  const [state, setState] = useState({
    errorCode: '',
    processed: false,
    disabledForm: false,
  })

  const submit = async ({
    password,
    passwordConfirmation,
    token,
    recaptchaResponse,
  }) => {
    setState((s) => ({ ...s, disabledForm: true }))
    try {
      await apiRequest(submitPasswordResetConfirmation, {
        token,
        user_password: password,
        user_password_confirmation: passwordConfirmation,
        'g-recaptcha-response': recaptchaResponse,
      })
      setState((s) => ({
        ...s,
        processed: true,
        errorCode: '',
        disabledForm: false,
      }))
    } catch (error) {
      setState((s) => ({ ...s, errorCode: error.message, disabledForm: false }))
    }
  }

  return { ...state, submit }
}
